export enum EditStatus {
    InProgress = 0,
    Allowed = 1
}